import { createSelector } from '@ngrx/store';

import { globalUiSelector } from '@app/store/selectors/global-ui.selector';
import { GlobalUi, GlobalUiResults } from '@app/store/state/global-ui.state';

export const selectGlobalUiResultsHandle = createSelector(globalUiSelector, (state: GlobalUi) => state?.results);

export const selectGlobalUiFiltersByResultsHandle = createSelector(
  selectGlobalUiResultsHandle, (state: GlobalUiResults) => state?.filters
);


